module.exports = __webpack_public_path__ + "img/30.8da5a9bc.jpg";